import type { FC, ReactNode } from "react"

interface ActionToolbarProps {
  children: ReactNode
}

const ActionToolbar: FC<ActionToolbarProps> = ({ children }) => {
  return <div className="mb-3 flex gap-3">{children}</div>
}

export default ActionToolbar
